var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _rect, _path26, _path27, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckNotAvailableCar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 107,
    viewBox: "0 0 85 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.7274 56.8904C77.1899 57.9554 77.5449 61.0904 77.5449 61.0904L78.9649 61.4429H73.46V63.4229C74.515 63.4479 75.6499 63.4554 76.7949 63.4229H76.8099C80.8599 63.2979 84.9074 62.6729 84.9949 60.6729C85.1724 56.6554 80.2649 55.8279 78.7274 56.8904Z",
    fill: "url(#paint0_linear_2119_1410)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.27215 56.8904C7.80964 57.9554 7.45465 61.0904 7.45465 61.0904L6.03465 61.4429H11.5396V63.4229C10.4846 63.4479 9.34963 63.4554 8.20464 63.4229H8.18964C4.13967 63.2979 0.0921923 62.6729 0.00469287 60.6729C-0.172806 56.6554 4.73466 55.8279 6.27215 56.8904Z",
    fill: "url(#paint1_linear_2119_1410)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9769 60.2872C82.2748 60.2872 83.3269 59.5026 83.3269 58.5347C83.3269 57.5668 82.2748 56.7822 80.9769 56.7822C79.6791 56.7822 78.627 57.5668 78.627 58.5347C78.627 59.5026 79.6791 60.2872 80.9769 60.2872Z",
    fill: "url(#paint2_linear_2119_1410)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.11952 60.2872C5.41738 60.2872 6.4695 59.5026 6.4695 58.5347C6.4695 57.5668 5.41738 56.7822 4.11952 56.7822C2.82165 56.7822 1.76953 57.5668 1.76953 58.5347C1.76953 59.5026 2.82165 60.2872 4.11952 60.2872Z",
    fill: "url(#paint3_linear_2119_1410)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8672 95.3623V103.24C64.8672 105.315 66.4847 107 68.4797 107H76.9121C78.9096 107 80.5271 105.317 80.5271 103.24V95.3623H64.8672Z",
    fill: "url(#paint4_linear_2119_1410)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M78.2891 95.3623C78.2891 100.5 74.2867 104.662 69.3492 104.662H66.2442C65.8317 104.662 65.4442 104.577 65.0742 104.445C65.5592 105.927 66.8917 107 68.4817 107H76.9141C78.9091 107 80.5266 105.317 80.5266 103.24V95.3623H78.2891Z",
    fill: "url(#paint5_linear_2119_1410)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.47266 95.3623V103.24C4.47266 105.315 6.09015 107 8.08514 107H16.5176C18.5126 107 20.1301 105.317 20.1301 103.24V95.3623H4.47266Z",
    fill: "url(#paint6_linear_2119_1410)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17.8921 95.3623C17.8921 100.5 13.8921 104.662 8.95216 104.662H5.84968C5.43968 104.662 5.04969 104.577 4.67969 104.445C5.16468 105.927 6.49968 107 8.08717 107H16.5196C18.5146 107 20.1321 105.317 20.1321 103.24V95.3623H17.8946H17.8921Z",
    fill: "url(#paint7_linear_2119_1410)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41745 62.7744H76.467L83.4895 72.3169C84.4746 73.6923 85.0028 75.3425 84.9995 77.0343V93.2042C84.9995 96.9667 82.0695 100.017 78.452 100.017H6.54996C2.92998 100.017 0 96.9667 0 93.2042V77.0343C0 75.3343 0.529997 73.6768 1.51249 72.3169L8.41745 62.7744Z",
    fill: "url(#paint8_linear_2119_1410)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41797 62.7749L16.5104 42.67C17.3504 40.74 19.2054 39.5 21.2429 39.5H63.7576C65.7976 39.5 67.6476 40.74 68.4901 42.67L76.47 62.7749H8.42047H8.41797Z",
    fill: "url(#paint9_linear_2119_1410)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1942 57.9449L66.8242 43.55C66.5767 42.89 66.0117 42.46 65.3867 42.46H19.5595C18.9345 42.46 18.367 42.8875 18.122 43.55L12.7495 57.9449C12.307 59.1299 13.062 60.4473 14.1845 60.4473H70.7542C71.8767 60.4473 72.6367 59.1299 72.1942 57.9449Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M72.1942 57.9449L66.8242 43.55C66.5767 42.89 66.0117 42.46 65.3867 42.46H61.3867C63.7817 48.8749 59.6867 56.0099 53.6118 56.0099H13.4695L12.7495 57.9424C12.307 59.1274 13.062 60.4448 14.1845 60.4448H70.7542C71.8767 60.4448 72.6342 59.1274 72.1917 57.9424L72.1942 57.9449Z",
    fill: "url(#paint10_linear_2119_1410)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5 83.7624C67.4149 82.3024 72.4749 78.7624 76.8699 78.4749C78.9274 78.3399 80.8124 79.9099 81.0824 82.0374C81.2399 83.2724 81.1024 84.6623 80.1374 85.7548C78.4099 87.7123 70.2299 87.5548 66.5324 87.3773C65.5075 87.3273 64.71 86.4473 64.71 85.3773C64.71 84.7374 65.0025 84.1424 65.5 83.7624Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5 83.7625C66.4745 83.024 67.4831 82.3316 68.5225 81.6875C68.1575 81.95 67.83 82.1875 67.5725 82.3875C67.3249 82.5774 67.1245 82.822 66.987 83.1022C66.8496 83.3823 66.7787 83.6904 66.78 84.0025C66.78 85.0725 67.58 85.9525 68.605 86.0025C71.5449 86.1425 77.3099 86.2675 80.4224 85.33C80.3274 85.4725 80.2574 85.6225 80.1374 85.755C78.4124 87.7125 70.23 87.555 66.5325 87.3775C65.5075 87.3275 64.71 86.4475 64.71 85.3775C64.7084 85.0656 64.7789 84.7576 64.9159 84.4775C65.053 84.1974 65.2528 83.9527 65.5 83.7625Z",
    fill: "url(#paint11_linear_2119_1410)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5002 83.7624C17.5827 82.3024 12.5252 78.7624 8.13023 78.4749C6.07274 78.3399 4.18776 79.9099 3.91776 82.0374C3.76026 83.2724 3.89776 84.6623 4.86275 85.7548C6.59024 87.7123 14.7702 87.5548 18.4677 87.3773C19.4927 87.3273 20.2902 86.4473 20.2902 85.3773C20.2915 85.0655 20.221 84.7576 20.084 84.4775C19.9469 84.1974 19.7472 83.9527 19.5002 83.7624Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4996 83.7625C18.525 83.0241 17.5164 82.3316 16.4771 81.6875C16.8446 81.95 17.1696 82.1875 17.4271 82.3875C17.6747 82.5774 17.875 82.822 18.0125 83.1022C18.15 83.3823 18.2208 83.6904 18.2196 84.0025C18.2196 85.0725 17.4196 85.9525 16.3946 86.0025C13.4546 86.1425 7.68963 86.2675 4.57715 85.33C4.67215 85.4725 4.74215 85.6225 4.86215 85.755C6.58713 87.7125 14.7696 87.555 18.4671 87.3775C19.4921 87.3275 20.2895 86.4475 20.2895 85.3775C20.2911 85.0656 20.2206 84.7576 20.0836 84.4775C19.9466 84.1974 19.7467 83.9527 19.4996 83.7625Z",
    fill: "url(#paint12_linear_2119_1410)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9618 69.0904L75.7168 65.7555C75.4721 65.3852 75.1399 65.0808 74.7497 64.8694C74.3595 64.6579 73.9231 64.5458 73.4793 64.543H11.3097C10.3747 64.543 9.50221 65.043 9.00222 65.8655L7.03723 69.0904C6.30973 70.6229 6.85473 72.7079 8.11722 73.2154L18.2347 77.2704C20.1701 78.0559 22.2384 78.4625 24.3271 78.4679H60.6719C62.7319 78.4679 64.7819 78.0629 66.7619 77.2679L76.8818 73.2129C78.1443 72.7079 78.6918 70.6229 77.9618 69.0879V69.0904Z",
    fill: "url(#paint13_linear_2119_1410)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3247 77.5345C22.3747 77.5345 20.4348 77.152 18.5573 76.3995L8.43983 72.3446C8.16484 72.2371 7.92234 71.9371 7.76984 71.5296C7.52734 70.8796 7.55234 70.1046 7.83984 69.5046L9.75732 66.3596C9.91777 66.0907 10.1451 65.8679 10.4171 65.7128C10.6891 65.5577 10.9967 65.4757 11.3098 65.4746H73.4794C74.0794 65.4746 74.6419 65.7796 74.9844 66.2896L77.2269 69.6246C77.4469 70.1046 77.4719 70.8821 77.2319 71.5296C77.0769 71.9396 76.8319 72.2371 76.5619 72.3446L66.442 76.3995C64.567 77.152 62.6245 77.5345 60.6745 77.5345H24.3247Z",
    fill: "url(#paint14_linear_2119_1410)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8575 78.3477H25.1427C24.4127 78.3477 23.9252 79.1277 24.2202 79.8226L28.0752 88.8676C28.2377 89.2476 28.6002 89.4926 29.0002 89.4926minHeight56C56.4 89.4926 56.76 89.2476 56.92 88.8676L60.7775 79.8226C61.0725 79.1277 60.585 78.3477 59.855 78.3477H59.8575Z",
    fill: "url(#paint15_linear_2119_1410)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M59.857 78.3477minHeight56.962C54.7945 83.4326 49.9496 86.7101 44.6046 86.7101H27.1572L28.0747 88.8676C28.2372 89.2476 28.5997 89.4926 28.9997 89.4926H55.9995C56.3995 89.4926 56.7595 89.2476 56.9195 88.8676L60.777 79.8226C61.072 79.1277 60.5845 78.3477 59.8545 78.3477H59.857Z",
    fill: "url(#paint16_linear_2119_1410)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3819 94.2744H11.6173L11.0098 95.0494C10.5748 95.6119 10.9573 96.4494 11.6498 96.4494H73.3494C74.0419 96.4494 74.4244 95.6119 73.9894 95.0494L73.3819 94.2744Z",
    fill: "url(#paint17_linear_2119_1410)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M83.487 72.3169L76.467 62.7744H76.0595L77.897 65.2744C78.907 66.6444 79.4545 68.3244 79.4545 70.0494C79.4545 82.7443 69.5646 93.0342 57.3671 93.0342H1.00249C0.657496 93.0342 0.327498 92.9817 0 92.9292V93.2042C0 96.9667 2.92998 100.017 6.54746 100.017H78.4545C82.0695 100.017 84.9995 96.9667 84.9995 93.2042V77.0343C85.0028 75.3425 84.4721 73.6923 83.487 72.3169Z",
    fill: "url(#paint18_linear_2119_1410)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M42 35.3495C51.5819 35.3495 59.3495 27.5819 59.3495 18C59.3495 8.41806 51.5819 0.650391 42 0.650391C32.4181 0.650391 24.6504 8.41806 24.6504 18C24.6504 27.5819 32.4181 35.3495 42 35.3495Z",
    fill: "#E69B9B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4329 3.4375C53.1954 6.15299 54.2198 9.39181 54.2198 12.8702C54.2198 22.4521 46.4521 30.2198 36.8702 30.2198C33.3918 30.2198 30.153 29.1954 27.4375 27.4329C30.5301 32.1975 35.8967 35.3497 42.0001 35.3497C51.582 35.3497 59.3497 27.582 59.3497 18.0001C59.3497 11.8967 56.1975 6.53012 51.4329 3.4375Z",
    fill: "#D76F6F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9999 32.3963C49.9508 32.3963 56.3963 25.9508 56.3963 17.9999C56.3963 10.049 49.9508 3.60352 41.9999 3.60352C34.049 3.60352 27.6035 10.049 27.6035 17.9999C27.6035 25.9508 34.049 32.3963 41.9999 32.3963Z",
    fill: "#C33E3E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30.2929,
    y: 9.822,
    width: 4,
    height: 28.8335,
    rx: 2,
    transform: "rotate(-44.8995 30.2929 9.822)",
    fill: "white",
    stroke: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M42 0C32.0747 0 24 8.07474 24 18C24 27.9253 32.0747 36 42 36C45.2636 36 48.461 35.1172 51.2464 33.4473C51.3939 33.3584 51.5001 33.2146 51.5417 33.0475C51.5833 32.8804 51.557 32.7036 51.4684 32.5559C51.3799 32.4082 51.2364 32.3016 51.0694 32.2596C50.9024 32.2176 50.7255 32.2435 50.5776 32.3317C47.9941 33.8805 45.0281 34.6993 42 34.6993C32.7921 34.6993 25.3008 27.2081 25.3008 18C25.3008 8.79216 32.792 1.30086 42 1.30086C51.2081 1.30086 58.6993 8.79207 58.6993 18C58.6993 22.843 56.5998 27.442 52.939 30.6179C52.8087 30.7309 52.7287 30.8911 52.7165 31.0631C52.7043 31.2352 52.7609 31.405 52.874 31.5353C52.9299 31.5999 52.998 31.6527 53.0744 31.6909C53.1508 31.7291 53.234 31.7519 53.3192 31.7579C53.4044 31.764 53.49 31.7532 53.571 31.7261C53.652 31.6991 53.7269 31.6564 53.7914 31.6004C57.7371 28.1773 60 23.2203 60 18C60 8.07474 51.9253 0 42 0Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5937 10.6739C29.5183 10.6337 29.4358 10.6087 29.3508 10.6004C29.2658 10.5921 29.18 10.6006 29.0982 10.6255C29.0165 10.6503 28.9405 10.6911 28.8745 10.7453C28.8086 10.7996 28.7539 10.8663 28.7138 10.9417C27.562 13.1009 26.9531 15.5415 26.9531 17.9995C26.9531 26.2966 33.7033 33.0468 42.0003 33.0468C50.2973 33.0468 57.0475 26.2966 57.0475 17.9995C57.0475 9.7029 50.2973 2.95312 42.0003 2.95312C37.5572 2.95312 33.3617 4.90896 30.4897 8.31914C30.4347 8.38446 30.3931 8.45998 30.3673 8.54138C30.3414 8.62278 30.3319 8.70848 30.3392 8.79358C30.3464 8.87867 30.3704 8.9615 30.4097 9.03732C30.449 9.11315 30.5029 9.18049 30.5682 9.23549C30.6335 9.29051 30.7091 9.33213 30.7905 9.35796C30.8719 9.38379 30.9576 9.39334 31.0427 9.38605C31.1277 9.37876 31.2106 9.35478 31.2864 9.31549C31.3622 9.27619 31.4296 9.22234 31.4846 9.15701C34.1088 6.04106 37.9417 4.25389 42.0002 4.25389C49.5801 4.25389 55.7467 10.4201 55.7467 17.9995C55.7467 25.5793 49.5801 31.746 42.0002 31.746C34.4204 31.746 28.2539 25.5793 28.2539 17.9995C28.2539 15.7543 28.8098 13.5253 29.8614 11.5538C29.9426 11.4016 29.96 11.2234 29.9098 11.0584C29.8596 10.8934 29.7459 10.7551 29.5937 10.6739Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2119_1410",
    x1: 79.2299,
    y1: 56.8004,
    x2: 79.2299,
    y2: 63.5229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F5F60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#282828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2119_1410",
    x1: 5.76966,
    y1: 56.8004,
    x2: 5.76966,
    y2: 63.5229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F5F60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#282828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2119_1410",
    x1: 82.0419,
    y1: 56.8397,
    x2: 80.3869,
    y2: 59.4722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2119_1410",
    x1: 3.05202,
    y1: 56.8397,
    x2: 4.70701,
    y2: 59.4722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2119_1410",
    x1: 72.6971,
    y1: 95.9173,
    x2: 72.6971,
    y2: 107.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F5F60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#282828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2119_1410",
    x1: 72.7992,
    y1: 95.9173,
    x2: 72.7992,
    y2: 107.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F5F60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#282828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2119_1410",
    x1: 12.3001,
    y1: 95.9173,
    x2: 12.3001,
    y2: 107.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F5F60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#282828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2119_1410",
    x1: 12.4046,
    y1: 95.9173,
    x2: 12.4046,
    y2: 107.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F5F60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#282828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2119_1410",
    x1: 42.4997,
    y1: 63.9494,
    x2: 42.4997,
    y2: 93.9142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4981F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2119_1410",
    x1: 42.4428,
    y1: 62.3949,
    x2: 42.4428,
    y2: 40.5525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4981F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2119_1410",
    x1: 12.622,
    y1: 51.4549,
    x2: 72.3217,
    y2: 51.4549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BDBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2119_1410",
    x1: 80.4224,
    y1: 84.5825,
    x2: 64.71,
    y2: 84.5825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2CFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2119_1410",
    x1: 4.57965,
    y1: 84.5825,
    x2: 20.2895,
    y2: 84.5825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2CFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2119_1410",
    x1: 42.4995,
    y1: 60.378,
    x2: 42.4995,
    y2: 75.1204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#197BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#257CFD",
    stopOpacity: 0.671
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#4480F9",
    stopOpacity: 0.078
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4981F8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2119_1410",
    x1: 45.7146,
    y1: 56.9747,
    x2: 42.5721,
    y2: 70.2921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2119_1410",
    x1: 42.5001,
    y1: 78.8027,
    x2: 42.5001,
    y2: 85.8226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F5F60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#282828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2119_1410",
    x1: 44.0121,
    y1: 78.8027,
    x2: 44.0121,
    y2: 85.8226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F5F60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#282828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2119_1410",
    x1: 42.4996,
    y1: 94.3644,
    x2: 42.4996,
    y2: 95.7319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F5F60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#282828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2119_1410",
    x1: 42.4997,
    y1: 63.9494,
    x2: 42.4997,
    y2: 93.9142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BDBFD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckNotAvailableCar);
export default __webpack_public_path__ + "static/media/CheckNotAvailableCar.3d79849bda7ebab05655b62b530cda9d.svg";
export { ForwardRef as ReactComponent };